import { useEffect, useState } from 'react'
import { getRedeemByID } from '../../api'
import { useParams } from 'react-router-dom';
import { ItemDetailCard, loginLogout, useProjectByStorage } from '../../projectData';
import { KTSVG } from '../../../../_metronic/helpers';
import { VoucherDetail } from './voucherDetail';
import { useRouteData } from '../../RouteDataContext';
import VocherOTPPopup from '../redemptionFiles/vocherVerification';
import { FullPageLoader } from '../../../component/helper';
import { BankTransferDetail } from './bankTransferDetail';



/**
 * PysicalProduct component
 * Displays details of a physical product redemption, including order info and delivery address.
 */
export const PysicalProduct = ({ data }) => {
    return <>
        <div className='col-sm-12 mt-4'>
            <div className="card  p-2" style={{ border: '1px solid #eaeaea', backgroundColor: "#EFEFEF" }}>
                <div className="d-flex justify-content-between  p-2 ">
                    <div className="fw-semibold fs-6">Redemption Id: <span className='fw-semibold'>{data?.order_id}</span></div>
                    <div className="fw-semibold fs-6">Date:<span className='fw-semibold'> {data?.order_date}</span> </div>
                </div>
                <>
                    <ItemDetailCard data={data} />
                </>
            </div>
        </div>
        <div className='col-sm-12 mt-4 card border shadow-sm'>
            <div className='card-title p-4 pb-0 fs-5 fw-semibold '>
                Delivery Address
            </div>
            <div className='p-4 pt-0'>
                <div className='col-12 mb-1'>
                    <div className='fs-6'>
                        <i className="fas fa-user fs-6 me-2 text-dark"></i> {data?.first_name} {data?.last_name}
                    </div>
                </div>
                <div className='col-12 mb-1'>
                    <div className='fs-6'>
                        <i className="fas fa-building fs-6 me-2 text-dark"></i> {data?.firm_name ? data?.firm_name : '--'}
                    </div>
                </div>
                <div className='col-12 mb-1'>
                    <div className='fs-6'>
                        <i className="fas fa-phone fs-6 me-2 text-dark"></i> {data?.phone ? data?.phone : '--'}
                    </div>
                </div>
                <div className='col-12'>
                    <div className='fs-6'>
                        <i className="fas fa-map-marker-alt fs-6 me-2 text-dark"></i> {data?.address ? data?.address : '--'}
                    </div>
                </div>
            </div>
        </div>
    </>
}


/**
 * GiftDetail component
 * Fetches and displays redemption details based on SKU type (voucher, bank transfer, or physical product).
 * Handles loading state, error display, and OTP popup for voucher download.
 */
export const GiftDetail = () => {
    const project = useProjectByStorage()
    const [data, setData] = useState(null);
    const [loader, setLoader] = useState(true);
    const { userData } = useRouteData();
    const [otp, setOtp] = useState(true)
    const { redem_id } = useParams();
    useEffect(() => {
        if (project) {
            setLoader(true);
            getData()
        }
    }, [project])

    const getData = () => {
        getRedeemByID({ ledgerID: redem_id, project_key: project?.pkey }).then((d) => {
            setData(d?.data)
            setTimeout(() => {
                setLoader(false);
            }, 500)
        }).catch((error) => {
            loginLogout(error.response)
        })

    }
    if (loader) {
        return <div className='container vh-100 bg-white mb-4 pt-4'>
            {loader &&
                <FullPageLoader />
            }
        </div>
    }
    return (
        <div className='container vh-100 bg-white mb-4 pt-4'>
            <div style={{ background: '#fefafa' }} className='card  mb-4'>
                <div className='card-body p-4 fs-5'>
                    Your  Redemption Detail
                </div>
            </div>
            {data ? <>
                {
                    data?.skuType === "voucher" ? (
                        <VoucherDetail data={data} />
                    ) : data?.skuType === "bank-transfer" ? (
                        <BankTransferDetail data={data} />
                    ) : (
                        <PysicalProduct data={data} />
                    )
                }
            </>
                : <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed p-2 mb-4">
                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger me-5' />
                    <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                        <div className=" mb-md-0 fw-semibold">
                            <div className="fs-7 text-gray-700 pe-7">
                                No data Found !
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                Number(data.voucher_download_status) !== 1 &&
                <>
                    {(otp && data?.status === 'Delivered' && data?.skuType === "voucher") &&
                        <VocherOTPPopup redem_id={redem_id} project_key={project?.pkey} reload={getData} show={otp} setShow={setOtp} mobile={userData?.user?.phone} />
                    }
                </>
            }
        </div >
    )
}
